"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchTypesTree = fetchTypesTree;
exports.addMilestoneType = addMilestoneType;
exports.addCaseType = addCaseType;
exports.attachMilestoneType = attachMilestoneType;
exports.editMilestoneType = editMilestoneType;
exports.editCaseType = editCaseType;
const MainSetupReact_1 = __importDefault(require("../../React/MainSetupReact"));
/**
 * Odczyt hierarchii typów.
 *
 * Świadomie BEZ RepositoryReact - to nie jest lista CRUD-owa, tylko jeden odczyt
 * całego grafu (około 180 wierszy) bez paginacji i filtrów.
 */
async function fetchTypesTree() {
    // Odczyt idzie trasą BEZ prefiksu /admin: tamten prefiks jest zamknięty dla
    // ENVI_EMPLOYEE, a podgląd hierarchii ma być dla wszystkich pracowników ENVI.
    // Zapis niżej zostaje pod /admin - to tam stoi bramka panelu.
    const response = await fetch(MainSetupReact_1.default.serverUrl + "typesTree", {
        credentials: "include",
    });
    if (!response.ok) {
        if (response.status === 403)
            throw new Error("Brak uprawnień do hierarchii typów.");
        if (response.status === 401)
            throw new Error("Sesja wygasła - zaloguj się ponownie.");
        throw new Error(`Nie udało się pobrać hierarchii typów (kod ${response.status}).`);
    }
    return (await response.json());
}
/**
 * Zapis zwraca CAŁE odświeżone drzewo. Doklejanie pojedynczego węzła po stronie
 * klienta rozjechałoby widok z bazą przy pierwszej rozbieżności.
 */
async function sendToTree(method, path, payload) {
    const response = await fetch(MainSetupReact_1.default.serverUrl + path, {
        method,
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    if (!response.ok) {
        let message = `Nie udało się zapisać (kod ${response.status}).`;
        try {
            const body = await response.json();
            if (body?.errorMessage)
                message = body.errorMessage;
            else if (typeof body === "string" && body)
                message = body;
        }
        catch {
            /* odpowiedź bez treści JSON - zostaje komunikat domyślny */
        }
        throw new Error(message);
    }
    return (await response.json());
}
function addMilestoneType(payload) {
    return sendToTree("POST", "admin/typesTree/milestoneType", payload);
}
function addCaseType(payload) {
    return sendToTree("POST", "admin/typesTree/caseType", payload);
}
function attachMilestoneType(payload) {
    return sendToTree("POST", "admin/typesTree/contractTypeMilestoneType", payload);
}
function editMilestoneType(id, payload) {
    return sendToTree("PUT", `admin/typesTree/milestoneType/${id}`, payload);
}
function editCaseType(id, payload) {
    return sendToTree("PUT", `admin/typesTree/caseType/${id}`, payload);
}
